export default "__VITE_ASSET__96ba51b6__"